
import Vue from "vue";

interface ITopMenuData {
  hovering: boolean;
}

interface Injected {
  callDoLogout: () => Promise<void>;
}

export default Vue.extend({
  name: "logout",

  inject: {
    callDoLogout: {
      from: "callDoLogout",
      default: () => async () => {} // fallback: empty async function
    }
  },

  data(): ITopMenuData {
    return {
      hovering: false
    };
  },

  computed: {
    icon(): string[] {
      return !this.hovering ? ["fas", "sign-out-alt"] : ["fal", "portal-exit"];
    }
  },

  methods: {
    async logout(this: Vue & Injected) {
      await this.callDoLogout();
    }
  }
});
